import React from 'react';

const SHADOWS = { none: 'none', sm: 'var(--shadow-sm)', md: 'var(--shadow-md)', lg: 'var(--shadow-lg)' };

/** Surface container — white on white, hairline border, soft neutral shadow. */
export default function Card({
  elevation = 'sm', interactive = false, pad = 'var(--space-5)',
  tone = 'default', style, children, ...rest
}) {
  const toneBg = tone === 'ink' ? 'var(--surface-ink)' : tone === 'sunk' ? 'var(--surface-raised)' : 'var(--neutral-0)';
  const toneFg = tone === 'ink' ? 'var(--on-ink)' : 'var(--ink)';
  const toneBorder = tone === 'ink' ? 'transparent' : 'var(--line)';
  return (
    <div
      style={{
        background: toneBg, color: toneFg,
        border: `1px solid ${toneBorder}`,
        borderRadius: 'var(--radius-card)',
        boxShadow: SHADOWS[elevation] || SHADOWS.sm,
        padding: pad,
        transition: 'box-shadow var(--dur-base) var(--ease-out), transform var(--dur-base) var(--ease-out)',
        cursor: interactive ? 'pointer' : undefined,
        ...style,
      }}
      onMouseEnter={interactive ? (e) => {
        e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
        e.currentTarget.style.transform = 'translateY(-3px)';
      } : undefined}
      onMouseLeave={interactive ? (e) => {
        e.currentTarget.style.boxShadow = SHADOWS[elevation] || SHADOWS.sm;
        e.currentTarget.style.transform = 'translateY(0)';
      } : undefined}
      {...rest}
    >
      {children}
    </div>
  );
}
